import { ReactNode } from 'react'

export const compareOverview: {
  title: string | ReactNode
  summary: string | ReactNode
}[] = [
  {
    title: 'Define metrics on the fly',
    summary: (
      <>
        Analysts can define or edit a metric the moment they need it through AI
        chat, Excel formulas, point-and-click, or SQL. No need for exports,
        stale copies, or filing tickets with the data team. Sync changes with
        Git and promote them safely through pull requests, the way your
        engineers already ship code.
      </>
    ),
  },
  {
    title: 'You have to migrate either way',
    summary: (
      <>
        Strategy’s AI runs only on their cloud, and their two-to-four week
        migration estimate covers environment setup, but not your reports or
        security model. Omni&apos;s experts work through them with you, using
        open-source tools and AI workflows to help accelerate the migration so
        you land on a modern, AI-driven platform.
      </>
    ),
  },
  {
    title: 'AI you can trust and verify',
    summary: (
      <>
        Omni’s AI applies each user&apos;s permissions and builds every answer
        from your semantic model&apos;s governed definitions and context. Users
        can start in AI, and open the answer in a workbook to see the fields,
        filters, and SQL behind it; then take over with point-and-click or
        spreadsheet analysis. The agent and user work in tandem.
      </>
    ),
  },
  {
    title: 'Build once, deploy on demand',
    summary: (
      <>
        Each business unit can extend the core model instead of standing up its
        own. Dashboards, data apps, and AI routines built on top carry the same
        permissions everywhere. In Strategy, every project stands alone, so what
        you built for one unit has to be built again for the next.
      </>
    ),
  },
  {
    title: 'Stop managing cubes',
    summary: (
      <>
        Strategy’s speed depends on cubes, in-memory copies of your data that a
        specialist has to size, schedule, and rebuild. Omni routes repeat
        questions to an{' '}
        <a
          href="https://docs.omni.co/analyze-explore/performance/caching"
          target="_blank"
          rel="noopener noreferrer"
        >
          intelligent cache
        </a>{' '}
        instead, with no maintenance required.
      </>
    ),
  },
]
